import ExternalPageWrapper from './ExternalPageWrapper';
export default ExternalPageWrapper;
